import {
  Award, Cpu, PencilRuler, Building2, Headphones,
  IndianRupee, Layers, Timer, MapPin,
} from "lucide-react";
import { USPS } from "@/data/content";

const ICONS = { Award, Cpu, PencilRuler, Building2, Headphones, IndianRupee, Layers, Timer, MapPin };

export default function UspGrid() {
  return (
    <section id="why-us" className="relative scroll-mt-24 overflow-hidden px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24" data-testid="usp-section">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <img
          data-parallax-img
          src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?q=80&w=1800&auto=format&fit=crop"
          alt=""
          className="absolute -top-[12%] left-0 h-[124%] w-full object-cover opacity-[0.06]"
        />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,87,34,0.06),transparent_55%)]" />
      </div>
      <div className="relative mx-auto max-w-7xl">
        <div className="mb-10 max-w-2xl sm:mb-14" data-reveal>
          <p className="kicker mb-4">Why Choose Us</p>
          <h2 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Nine reasons clients stay with us for decades
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 sm:text-base">
            Since 2002, BIGBOSS DIGITECH has executed 15,000+ residential, commercial and government
            projects across India. Every system is engineered by electronics specialists, installed by
            our own team, and backed by a dedicated service department with a 12–24 hour response
            promise.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
          {USPS.map((u, i) => {
            const Icon = ICONS[u.icon];
            const stagger = i % 4 === 1 ? "lg:mt-10" : i % 4 === 3 ? "lg:mt-16" : "";
            const wide = u.img ? "sm:col-span-2" : "";
            return (
              <article
                key={u.title}
                data-testid={`usp-card-${i + 1}`}
                data-reveal
                data-delay={(i % 4) * 0.07}
                className={`group relative overflow-hidden rounded-2xl border border-slate-700/70 transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/60 ${stagger} ${wide} ${
                  u.img ? "min-h-[220px]" : "bg-slate-900/60 p-6"
                }`}
              >
                {u.img ? (
                  <>
                    <img
                      src={u.img}
                      alt={u.title}
                      loading="lazy"
                      className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19] via-[#0B0F19]/55 to-[#0B0F19]/20" />
                    <div className="relative flex h-full min-h-[220px] flex-col justify-end p-6">
                      <Icon size={22} className="mb-3 text-brand" />
                      <h3 className="font-heading text-lg font-semibold text-white">{u.title}</h3>
                      <p className="mt-1.5 text-xs leading-relaxed text-slate-300 sm:text-sm">{u.text}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-slate-700 bg-white/[0.03] text-brand transition-colors duration-300 group-hover:border-brand/50">
                      <Icon size={20} />
                    </span>
                    <h3 className="font-heading text-base font-semibold text-white sm:text-lg">{u.title}</h3>
                    <p className="mt-2 text-xs leading-relaxed text-slate-400 sm:text-sm">{u.text}</p>
                  </>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
